'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

var index$1 = require('../../../node_modules/classnames/index.js');

var index = require('../../../node_modules/prop-types/index.js');

var NavPrimaryItem = require('../NavPrimaryItem/NavPrimaryItem.js');

var useOutsideClick = require('../../../utilities/hooks/useOutsideClick.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var NavPrimary = function NavPrimary(props) {
  var className = props.className,
      setActiveItemCb = props.setActiveItemCb,
      activeNavItem = props.activeNavItem,
      primaryNavData = props.primaryNavData;
  var ref = React.useRef();
  var navprimaryClasses = index$1['default']('navprimary', className, 'lanl-navprimary');
  useOutsideClick.useOutsideClick(ref, function () {
    setActiveItemCb(null);
  });

  var renderNavItems = function renderNavItems() {
    return primaryNavData.map(function (_ref, i) {
      var name = _ref.name,
          link = _ref.link;
      return /*#__PURE__*/React__default['default'].createElement(NavPrimaryItem.NavPrimaryItem, {
        key: "navPrimaryItem-".concat(i),
        active: name === activeNavItem
      }, link ? /*#__PURE__*/React__default['default'].createElement("a", {
        href: link,
        className: 'nav-primary-item'
      }, name) : name);
    });
  };

  return /*#__PURE__*/React__default['default'].createElement("div", {
    "data-testid": "lanl-navprimary",
    className: navprimaryClasses,
    onClick: function onClick(e) {
      return setActiveItemCb(e.target.innerText);
    },
    ref: ref
  }, renderNavItems());
};

NavPrimary.defaultProps = {
  activeNavItem: null,
  primaryNavData: [],
  searchIsActive: false,
  setActiveItemCb: function setActiveItemCb() {}
};
NavPrimary.propTypes = {
  activeNavItem: index['default'].string,
  className: index['default'].string,
  primaryNavData: index['default'].array,
  searchIsActive: index['default'].bool,
  setActiveItemCb: index['default'].func
};
exports.NavPrimary = NavPrimary;
exports['default'] = NavPrimary;